import type { Paginate } from 'types';
import { isPaginatedDTO } from 'utils/guards';

import {
  OrganizationMemberStatusDTO,
  type OrganizationDetailsDTO,
  type OrganizationEntryDTO,
  type OrganizationInvitationDTO,
  type OrganizationMemberDTO,
} from './dtos';
import type {
  OrganizationDetailsModel,
  OrganizationEntryModel,
  OrganizationInvitationModel,
  OrganizationMemberModel,
} from './models';
import { OrganizationMemberStatus } from './types';

export function toOrganizationEntryModel(from: OrganizationEntryDTO): OrganizationEntryModel {
  return from;
}

export function toOrganizationMemberStatus(from: OrganizationMemberStatusDTO): OrganizationMemberStatus {
  if (from === OrganizationMemberStatusDTO.PENDING) return OrganizationMemberStatus.PENDING;
  if (from === OrganizationMemberStatusDTO.EXPIRED) return OrganizationMemberStatus.EXPIRED;

  return OrganizationMemberStatus.ACTIVE;
}

export function toOrganizationMemberModel(from: OrganizationMemberDTO): OrganizationMemberModel;
export function toOrganizationMemberModel(from: OrganizationMemberDTO[]): OrganizationMemberModel[];
export function toOrganizationMemberModel(from: Paginate<OrganizationMemberDTO>): Paginate<OrganizationMemberModel>;

export function toOrganizationMemberModel(
  from: OrganizationMemberDTO | OrganizationMemberDTO[] | Paginate<OrganizationMemberDTO>,
): OrganizationMemberModel | OrganizationMemberModel[] | Paginate<OrganizationMemberModel> {
  if (Array.isArray(from)) {
    return from.map((item) => toOrganizationMemberModel(item));
  }

  if (isPaginatedDTO(from)) {
    const { data, ...rest } = from;

    return { ...rest, data: toOrganizationMemberModel(data) };
  }

  const { status, id, ...rest } = from;

  return { ...rest, id: id ?? undefined, status: toOrganizationMemberStatus(status) };
}

export function toOrganizationInvitationModel({
  status,
  ...from
}: OrganizationInvitationDTO): OrganizationInvitationModel {
  return { ...from, status: toOrganizationMemberStatus(status) };
}

export function toOrganizationDetailsModel(from: OrganizationDetailsDTO): OrganizationDetailsModel {
  return from;
}
